import { queryOptions, skipToken } from '@tanstack/react-query';

/**
 * Cache key for the backend's reported platform version. It is global — not
 * scoped to a transaction — so it is kept under a `global` tier. The value is
 * pushed into the cache by the SSE heartbeat (see serverEvents.ts), never
 * fetched, so the query that reads it never runs a queryFn.
 */
export const platformVersionKeys = {
  current: () => ['global', 'platform-version'] as const
};

/**
 * The backend's platform version as reported by the realtime SSE heartbeat.
 *
 * This query never fetches: `skipToken` disables it, and the value is written
 * into the cache by the heartbeat handler in serverEvents.ts via
 * `setQueryData`. Exposing it through `queryOptions` keeps the key in one place
 * (the factory above) so the writer and every reader cannot drift. `data` is
 * therefore `unknown` until the first heartbeat arrives — callers narrow it.
 */
export const platformVersionQuery = () =>
  queryOptions({
    queryKey: platformVersionKeys.current(),
    queryFn: skipToken
  });
